import script from "./ElevatedUsersBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ElevatedUsersBox.vue?vue&type=script&setup=true&lang=js"

import "./ElevatedUsersBox.vue?vue&type=style&index=0&id=15ad0c4f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ad0c4f"]])

export default __exports__